import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdalService } from '../shared/azure-authentication/adal.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    constructor(private router: Router, private adalService: AdalService) { }

    ngOnInit() {
      if (!this.isLoggedIn)
        this.adalService.login();
    }

    login() {
        this.adalService.login();
    }

    logout() {
        this.adalService.logout();
    }

    public get isLoggedIn() {
        return this.adalService.isAuthenticated;
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/login/login.component.ts